// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b9612e7b6f8c23ced7790d3c1fb293fe9c516dc8.chunk.js";
};